export default __webpack_public_path__ + "static/media/sch4_w640.2452c9cb.jpg";